<template>
  <div>
    <div ref="loader">
      <b-overlay :show="show" no-wrap fixed>
        <template #overlay>
          <div v-if="isFileUploadProgress" class="mb-4">
            <b-overlay :show="show"></b-overlay>
          </div>
          <div v-if="isFileUploadProgress">
            <h5 class="mt-3">Uploading file, please wait...</h5>
          </div>
          <b-progress height="2rem" style="width: 1000px" :max="maxPer">
            <b-progress-bar
              :value="progressValue"
              :label="`${((progressValue / maxPer) * 100).toFixed(2)}%`"
            ></b-progress-bar>
          </b-progress>
          <div class="mt-2" v-if="isSuccessFileUpload">
            <p class="text-secondary">
              File uploaded successfully. Total added rows: {{ totalAddedRows }}
            </p>
          </div>
          <div class="mt-3" v-if="isFileUploadInvalidData">
            <p class="text-dark">
              There are some entries which are invalid and not saved. Please
              download following csv to check details.
            </p>
            <div>
              <a
                id="invalid-file"
                class="btn btn-primary btn-sm"
                :href="invalidFileUploadLocation"
                download
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  fill="currentColor"
                  class="bi bi-download"
                  viewBox="0 0 16 16"
                >
                  <path
                    d="M.5 9.9a.5.5 0 0 1 .5.5v2.5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-2.5a.5.5 0 0 1 1 0v2.5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-2.5a.5.5 0 0 1 .5-.5z"
                  />
                  <path
                    d="M7.646 11.854a.5.5 0 0 0 .708 0l3-3a.5.5 0 0 0-.708-.708L8.5 10.293V1.5a.5.5 0 0 0-1 0v8.793L5.354 8.146a.5.5 0 1 0-.708.708l3 3z"
                  />
                </svg>
                Download</a
              >&nbsp;&nbsp;&nbsp;
              <a class="btn btn-secondary btn-sm" @click="closeOverlay"
                ><svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  fill="currentColor"
                  class="bi bi-x"
                  viewBox="0 0 16 16"
                >
                  <path
                    d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z"
                  />
                </svg>
                Close</a
              >
            </div>
          </div>
        </template>
      </b-overlay>
    </div>
    <ValidationObserver ref="observer1">
      <form
        ref="file1"
        slot-scope="{ validate }"
        @submit.prevent="
          validate().then((valid) => {
            if (valid) {
              handleUploadFile(file1, 'geneCommonName');
            }
          })
        "
      >
        <b-card>
          <p class="text-left ml-4 text-dark">Gene Common Name CSV Upload</p>
          <p class="text-left ml-4">
            <a
              href="../../assets/sampleCSV/gene_common_name_sample.csv"
              download
              >Download Sample CSV</a
            >
          </p>
          <b-row ols="6" class="ml-3">
            <b-col cols="3">
              <ValidationProvider rules="required" name="Species name">
                <b-form-group
                  label="Species"
                  class="text-left"
                  slot-scope="{ valid, errors }"
                >
                  <b-form-select
                    v-model="speciesID_DNA"
                    :options="speciesList"
                    :state="errors[0] ? false : valid ? true : null"
                    value-field="id"
                    text-field="name"
                    class="
                      border-top-0 border-right-0 border-left-0
                      selectInput
                    "
                    @input="getExperimentsGENE"
                  ></b-form-select>
                  <b-form-invalid-feedback>
                    {{ errors[0] }}
                  </b-form-invalid-feedback>
                </b-form-group>
              </ValidationProvider>
            </b-col>
            <b-col cols="3">
              <ValidationProvider rules="required" name="Experiment name">
                <b-form-group
                  label="Experiment"
                  slot-scope="{ valid, errors }"
                  class="text-left"
                >
                  <b-form-select
                    v-model="experimentId_GENE"
                    :state="errors[0] ? false : valid ? true : null"
                    :options="experimentList_GENE"
                    value-field="id"
                    text-field="name"
                    class="border-top-0 border-right-0 selectInput"
                    @input="onExperimentChange"
                  ></b-form-select>
                  <b-form-invalid-feedback>
                    {{ errors[0] }}
                  </b-form-invalid-feedback>
                </b-form-group>
              </ValidationProvider>
            </b-col>
          </b-row>
          <b-row ols="6" class="ml-3">
            <div class="is-invalid" style="width: 100% !important">
              <b-col cols="5">
                <ValidationProvider
                  rules="required|ext:csv|size:2000000"
                  name="Gene common-name csv"
                >
                  <b-form-group slot-scope="{ valid, errors }">
                    <b-form-file
                      v-model="file1"
                      placeholder="Choose a file or drop it here..."
                      drop-placeholder="Drop file here..."
                      :state="errors[0] ? false : valid ? true : null"
                      accept=".csv"
                      @change="validate"
                    ></b-form-file>
                    <b-form-invalid-feedback>
                      {{ errors[0] }}
                    </b-form-invalid-feedback>
                  </b-form-group>
                </ValidationProvider>
              </b-col>
              <b-col cols="2">
                <div class="input-group-append">
                  <button class="btn btn-secondary" type="submit" block>
                    Submit
                  </button>
                </div>
              </b-col>
            </div>
          </b-row>
        </b-card>
      </form>
    </ValidationObserver>

    <ValidationObserver ref="observer2">
      <form
        ref="fileTwo"
        slot-scope="{ validate }"
        @submit.prevent="
          validate().then((valid) => {
            if (valid) {
              handleUploadFile(file2, 'dna');
            }
          })
        "
      >
        <b-card class="mt-4">
          <p class="text-left ml-4 text-dark">DNA CSV Upload</p>
          <p class="text-left ml-4">
            <b-link href="../../assets/sampleCSV/dna_sample.csv" download
              >Download Sample CSV</b-link
            >
          </p>
          <b-row ols="6" class="ml-3">
            <b-col cols="3">
              <ValidationProvider rules="required" name="Species name">
                <b-form-group
                  label="Species"
                  class="text-left"
                  slot-scope="{ valid, errors }"
                >
                  <b-form-select
                    v-model="speciesID_DNA"
                    :options="speciesList"
                    :state="errors[0] ? false : valid ? true : null"
                    value-field="id"
                    text-field="name"
                    class="
                      border-top-0 border-right-0 border-left-0
                      selectInput
                    "
                    @input="getExperimentsDNA"
                  ></b-form-select>
                  <b-form-invalid-feedback>
                    {{ errors[0] }}
                  </b-form-invalid-feedback>
                </b-form-group>
              </ValidationProvider>
            </b-col>
            <b-col cols="3">
              <ValidationProvider rules="required" name="Experiment name">
                <b-form-group
                  label="Experiment"
                  slot-scope="{ valid, errors }"
                  class="text-left"
                >
                  <b-form-select
                    v-model="experimentId_DNA"
                    :state="errors[0] ? false : valid ? true : null"
                    :options="experimentList_DNA"
                    value-field="id"
                    text-field="name"
                    class="border-top-0 border-right-0 selectInput"
                    @input="onExperimentChange"
                  ></b-form-select>
                  <b-form-invalid-feedback>
                    {{ errors[0] }}
                  </b-form-invalid-feedback>
                </b-form-group>
              </ValidationProvider>
            </b-col>
          </b-row>
          <b-row ols="6" class="ml-3">
            <div class="is-invalid" style="width: 100% !important">
              <b-col cols="5">
                <ValidationProvider
                  rules="required|ext:csv|size:2000000"
                  name="DNA csv"
                >
                  <b-form-group slot-scope="{ valid, errors }">
                    <b-form-file
                      v-model="file2"
                      placeholder="Choose a file or drop it here..."
                      drop-placeholder="Drop file here..."
                      :state="errors[0] ? false : valid ? true : null"
                      accept=".csv"
                    ></b-form-file>
                    <b-form-invalid-feedback>
                      {{ errors[0] }}
                    </b-form-invalid-feedback>
                  </b-form-group>
                </ValidationProvider>
              </b-col>
              <b-col cols="2">
                <div class="input-group-append">
                  <button class="btn btn-secondary" type="submit" block>
                    Submit
                  </button>
                </div>
              </b-col>
            </div>
          </b-row>
        </b-card>
      </form>
    </ValidationObserver>

    <ValidationObserver ref="observer3">
      <form
        ref="file3"
        slot-scope="{ validate }"
        @submit.prevent="
          validate().then((valid) => {
            if (valid) {
              handleUploadFile(file3, 'cellExperiment');
            }
          })
        "
      >
        <b-card class="mt-3">
          <p class="text-left ml-3 text-dark">Cell Experiment CSV Upload</p>
          <p class="text-left ml-3">
            <b-link href="../../assets/sampleCSV/cell_exp_sample.csv" download
              >Download Sample CSV</b-link
            >
          </p>
          <b-row ols="6" class="ml-3">
            <b-col cols="3">
              <ValidationProvider rules="required" name="Species name">
                <b-form-group
                  label="Species"
                  slot-scope="{ valid, errors }"
                  class="text-left"
                >
                  <b-form-select
                    v-model="speciesID_CELL"
                    :options="speciesList"
                    value-field="id"
                    :state="errors[0] ? false : valid ? true : null"
                    text-field="name"
                    class="
                      border-top-0 border-right-0 border-left-0
                      selectInput
                    "
                    @input="getExperimentsCELL"
                  ></b-form-select>
                  <b-form-invalid-feedback>
                    {{ errors[0] }}
                  </b-form-invalid-feedback>
                </b-form-group>
              </ValidationProvider>
            </b-col>
            <b-col cols="3">
              <ValidationProvider rules="required" name="Experiment name">
                <b-form-group
                  label="Experiment"
                  slot-scope="{ valid, errors }"
                  class="text-left"
                >
                  <b-form-select
                    v-model="experimentId_CELL"
                    :state="errors[0] ? false : valid ? true : null"
                    :options="experimentList_CELL"
                    value-field="id"
                    text-field="name"
                    class="
                      border-top-0 border-right-0 border-left-0
                      selectInput
                    "
                    @input="onExperimentChange"
                  ></b-form-select>
                  <b-form-invalid-feedback>
                    {{ errors[0] }}
                  </b-form-invalid-feedback>
                </b-form-group>
              </ValidationProvider>
            </b-col>
          </b-row>
          <b-row ols="6" class="ml-3">
            <div class="is-invalid" style="width: 100% !important">
              <b-col cols="5">
                <ValidationProvider
                  rules="required|ext:csv|size:2000000"
                  name="Cell experiment csv"
                >
                  <b-form-group slot-scope="{ valid, errors }">
                    <b-form-file
                      v-model="file3"
                      placeholder="Choose a file or drop it here..."
                      drop-placeholder="Drop file here..."
                      :state="errors[0] ? false : valid ? true : null"
                      accept=".csv"
                    ></b-form-file>
                    <b-form-invalid-feedback>
                      {{ errors[0] }}
                    </b-form-invalid-feedback>
                  </b-form-group>
                </ValidationProvider>
              </b-col>
              <b-col cols="2">
                <div class="input-group-append">
                  <button class="btn btn-secondary" type="submit" block>
                    Submit
                  </button>
                </div>
              </b-col>
            </div>
          </b-row>
        </b-card>
      </form>
    </ValidationObserver>
  </div>
</template>
<script>
import { GET_SPECIES, GET_EXPERIMENTS } from "../../graphql/fetch-grphql";
import {
  ValidationObserver,
  ValidationProvider,
} from "vee-validate/dist/vee-validate.full";

import AWS from "aws-sdk";
import { uuid } from "vue-uuid";
import { CSVUPLOAD_MUTATION } from "../../graphql/fetch-grphql";
import { toastification } from "../../@core/mixins/toastification";
AWS.config.update({
  region: "us-east-2",
  credentials: new AWS.CognitoIdentityCredentials({
    IdentityPoolId: "us-east-2:519c5938-0d24-496d-b187-077447917bab",
  }),
});

export default {
  name: "CsvUpload",
  components: {
    ValidationObserver,
    ValidationProvider,
  },
  data() {
    return {
      file1: null,
      file2: null,
      file3: null,
      speciesID_DNA: "",
      speciesTitle_DNA: "",
      experimentList_DNA: [],
      experimentId_DNA: "",
      speciesList: [],
      speciesID_CELL: "",
      speciesTitle_CELL: "",
      experimentList_CELL: [],
      experimentId_CELL: "",
      experimentList_GENE: [],
      experimentId_GENE: "",
      uuid: uuid.v1(),
      show: false,
      maxPer: 100,
      progressValue: 0,
      interval_time: 1000,
      isFileUploadProgress: false,
      isFileUploadInvalidData: false,
      invalidFileUploadLocation: "",
      totalAddedRows: 0,
      isSuccessFileUpload: false,
    };
  },
  mixins: [toastification],
  beforeMount() {
    this.getSpecies();
  },
  methods: {
    getSpecies() {
      this.$apollo
        .query({
          query: GET_SPECIES,
        })
        .then((res) => {
          // console.log(res);
          this.speciesList = res.data.getSpecies.speciesList;
          if (this.speciesList.length) {
            this.speciesID_DNA = res.data.getSpecies.speciesList[0].id;
            this.speciesID_CELL = res.data.getSpecies.speciesList[0].id;
            this.speciesTitle_DNA = this.speciesList.filter(
              (species) => this.speciesID_DNA === species.id
            )[0].name;

            this.speciesTitle_CELL = this.speciesTitle_DNA;
            // this.getSpeciesName();
          }
        })
        .catch((err) => {
          this.makeToastFail(err);
        });
    },
    onExperimentChange() {
      // console.log(data);
    },
    getExperimentsDNA(speciesId) {
      // console.log(speciesId);
      this.$apollo
        .query({
          query: GET_EXPERIMENTS,
          variables: {
            species_id: speciesId,
          },
        })
        .then((res) => {
          // console.log(res);
          this.experimentList_DNA = res.data.getExperiments.experimentList;
          if (this.experimentList_DNA.length) {
            this.experimentId_DNA =
              res.data.getExperiments.experimentList[0].id;
          }
        })
        .catch((err) => {
          this.makeToastFail(err);
        });
    },

    getExperimentsGENE(speciesId) {
      // console.log(speciesId);
      this.$apollo
        .query({
          query: GET_EXPERIMENTS,
          variables: {
            species_id: speciesId,
          },
        })
        .then((res) => {
          // console.log(res);
          this.experimentList_GENE = res.data.getExperiments.experimentList;
          if (this.experimentList_GENE.length) {
            this.experimentId_GENE =
              res.data.getExperiments.experimentList[0].id;
          }
        })
        .catch((err) => {
          this.makeToastFail(err);
        });
    },

    getExperimentsCELL(speciesId) {
      // console.log(speciesId);
      this.$apollo
        .query({
          query: GET_EXPERIMENTS,
          variables: {
            species_id: speciesId,
          },
        })
        .then((res) => {
          // console.log(res);
          this.experimentList_CELL = res.data.getExperiments.experimentList;
          if (this.experimentList_CELL.length) {
            this.experimentId_CELL =
              res.data.getExperiments.experimentList[0].id;
          }
        })
        .catch((err) => {
          this.makeToastFail(err);
        });
    },
    closeOverlay() {
      this.show = false;
    },
    async showProgressbar(current_progress, interval_time, clear_interval_on) {
      var interval = setInterval(() => {
        current_progress += 1;
        if (current_progress >= clear_interval_on) {
          clearInterval(interval);
        }
        this.progressValue = current_progress;
      }, interval_time);
      return interval;
    },
    uploadFile({ fileName, file, contentType }) {
      return new AWS.S3.ManagedUpload({
        params: {
          Bucket: process.env.VUE_APP_BUCKET_NAME,
          Key: fileName,
          ContentType: contentType,
          Body: file,
          ACL: "public-read",
        },
      }).promise();
    },
    async handleSendFile(file, firstInterval) {
      const uploadParams = {
        contentType: file.type,
        fileName: `csvUploads/${this.uuid}.csv`,
        file,
      };
      try {
        const result = await this.uploadFile(uploadParams);
        clearInterval(firstInterval);
        return result;
      } catch (err) {
        clearInterval(firstInterval);
        this.show = false;
      }
    },
    async handleUploadFile(file, type) {
      // hide all upload flages.
      this.isFileUploadInvalidData = false;

      let message = `Please confirm that you want to upload data for selected Species and Experiment.`;

      this.$bvModal
        .msgBoxConfirm(`${message}`, {
          title: "Please Confirm",
          size: "sm",
          buttonSize: "sm",
          okVariant: "danger",
          okTitle: "YES",
          cancelTitle: "NO",
          footerClass: "p-2",
          hideHeaderClose: false,
          centered: true,
        })
        .then(async (value) => {
          if (value) {
            if (file.type === "text/csv" && file.size < 1073741824 * 2) {
              try {
                if (file.size / 1000840 > 50) {
                  this.interval_time = 3000;
                } else if (file.size / 1000840 > 100) {
                  this.interval_time = 6000;
                } else if (file.size / 1000840 > 500) {
                  this.interval_time = 100000;
                } else if (file.size / 1000840 > 1000) {
                  this.interval_time = 200000;
                }
                let firstInterval = await this.showProgressbar(
                  0,
                  this.interval_time,
                  25
                );

                this.show = true;
                this.isFileUploadProgress = true;

                let el = this.$refs.loader;
                let top = el.offsetTop;
                window.scrollTo(0, top);

                const fileResponse = await this.handleSendFile(
                  file,
                  firstInterval
                );
                let experiment_id;
                if (type == "cellExperiment") {
                  experiment_id = this.experimentId_CELL
                    ? this.experimentId_CELL
                    : "";
                } else if (type == "dna") {
                  experiment_id = this.experimentId_DNA;
                } else {
                  experiment_id = this.experimentId_GENE;
                }
                // console.log(experiment_id);
                if (fileResponse && experiment_id) {
                  let secondInterval = await this.showProgressbar(
                    26,
                    this.interval_time,
                    95
                  );

                  let thirdInterval;
                  this.$apollo
                    .mutate({
                      mutation: CSVUPLOAD_MUTATION,
                      variables: {
                        fileName: file.name,
                        experiment_id: `${experiment_id}`,
                        key: fileResponse.Key,
                        location: fileResponse.Location,
                        type: `${type}Process`,
                      },
                    })
                    .then(async (res) => {
                      clearInterval(secondInterval);
                      thirdInterval = await this.showProgressbar(
                        96,
                        this.interval_time,
                        100
                      );
                      setTimeout(() => {
                        this.isFileUploadProgress = false;
                        this.isSuccessFileUpload = true;
                        this.totalAddedRows = res.data.csvUpload.addedRowsCount;
                        if (res.data.csvUpload.location !== "") {
                          this.invalidFileUploadLocation =
                            res.data.csvUpload.location;
                          this.isFileUploadInvalidData = true;
                        } else {
                          if (type == "cellExperiment") {
                            this.$refs.observer3.reset();
                            this.file3 = [];
                          } else if (type == "dna") {
                            this.$refs.observer2.reset();
                            this.file2 = [];
                          } else {
                            this.$refs.observer1.reset();
                            this.file1 = [];
                          }
                          setTimeout(() => {
                            this.isSuccessFileUpload = false;
                            this.isFileUploadInvalidData = false;
                            this.progressValue = 0;
                            this.closeOverlay();
                          }, 9000);
                        }
                        clearInterval(thirdInterval);
                        this.$emit("getUploadLogs");
                      }, 6000);
                    })
                    .catch((err) => {
                      this.isFileUploadProgress = false;
                      this.isSuccessFileUpload = false;
                      this.isFileUploadInvalidData = false;
                      clearInterval(secondInterval);
                      this.show = false;
                      this.makeToastFail(err);
                    });
                }
              } catch (err) {
                this.makeToastFail(err);
                this.isFileUploadProgress = false;
                this.isSuccessFileUpload = false;
                this.isFileUploadInvalidData = false;
              }
            } else {
              return;
            }
          } else {
            this.file1 = [];
            this.file2 = [];
            this.file3 = [];
          }
        })
        .catch(() => {
          // console.log(err);
          // An error occurred
        });
    },
  },
  props: ["getUploadLogs"],
};
</script>
<style scoped>
.is-invalid {
  display: flex;
  width: 75%;
}
.is-invalid span {
  width: 100%;
}
.is-invalid .input-group-append {
  display: block;
  margin-left: 15px;
}
.custom-file {
  width: 100%;
}
@media only screen and (min-width: 360px) and (max-width: 736px) {
  .p-3 {
    padding: unset !important;
  }
  .w-75 {
    width: auto !important;
  }
}
@media only screen and (min-width: 768px) and (max-width: 1024px) {
  .p-3 {
    padding: unset;
  }
  .w-75 {
    width: auto;
  }
}
</style>
